import { useEffect, useState } from 'react';
import { createPublicApiClient } from '../../../utils/apiClient';
import { createCampaignAlertBadgeApi, CampaignAlertBadgeData } from '../shared/campaignAlertBadgeApi';

interface UseCampaignAlertBadgeParams {
  enabled: boolean;
}

const useCampaignAlertBadge = ({ enabled }: UseCampaignAlertBadgeParams): CampaignAlertBadgeData => {
  const [badge, setBadge] = useState<CampaignAlertBadgeData>({ count: 0, subscribed: false });

  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;
    const api = createCampaignAlertBadgeApi({ api: createPublicApiClient() });

    api
      .getAlertBadge()
      .then((data) => {
        if (!cancelled) setBadge(data);
      })
      .catch(() => {
        if (!cancelled) setBadge({ count: 0, subscribed: false });
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return badge;
};

export default useCampaignAlertBadge;
